/**
 * Generates cryptographically strong UUID v4.
 * Supports iOS 15.4+ (via randomUUID)
 * and older versions of iOS 11+ (via getRandomValues).
 */
export const generateUUID = () => {
  try {
    if (
      typeof crypto !== 'undefined' &&
      typeof crypto.randomUUID === 'function'
    ) {
      return crypto.randomUUID()
    }

    if (
      typeof crypto !== 'undefined' &&
      typeof crypto.getRandomValues === 'function'
    ) {
      const buffer = new Uint8Array(16)
      crypto.getRandomValues(buffer)

      // set version 4
      buffer[6] = (buffer[6] & 0x0f) | 0x40
      // set RFC 4122
      buffer[8] = (buffer[8] & 0x3f) | 0x80

      const hex = Array.from(buffer).map((b) => b.toString(16).padStart(2, '0'))

      return (
        `${hex.slice(0, 4).join('')}-${hex.slice(4, 6).join('')}-${hex.slice(6, 8).join('')}-` +
        `${hex.slice(8, 10).join('')}-${hex.slice(10, 16).join('')}`
      )
    }
  } catch (e) {
    console.error('UUID Generation Error:', e)
  }

  throw new Error('Crypto generation error')
}
